import { render, staticRenderFns } from "./PurgerPrivacy.vue?vue&type=template&id=cbef0e80&scoped=true&"
import script from "./PurgerPrivacy.vue?vue&type=script&lang=js&"
export * from "./PurgerPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./PurgerPrivacy.vue?vue&type=style&index=0&id=cbef0e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbef0e80",
  null
  
)

export default component.exports